import { useCallback } from 'react';
import useUserDetails from '../hooks/useUserDetails';
import { getGeneratedSurveyReport } from '../../services/surveyReportWorkflowService';
import ViewReportLink from '../reusable/ViewReportLink';

interface ViewSurveyReportLinkProps {
  schoolId: string;
}

const ViewSurveyReportLink = ({ schoolId }: ViewSurveyReportLinkProps) => {
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();

  const fetchUrl = useCallback(async () => {
    if (!userDetails) return null;
    const report = await getGeneratedSurveyReport(userDetails.eoaId, schoolId, userDetails.access_token);
    return report.pdf_download_url ?? null;
  }, [userDetails, schoolId]);

  return <ViewReportLink fetchUrl={fetchUrl} />;
};

export default ViewSurveyReportLink;
